import { Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import useSWR from 'swr';

import { withQueryParams } from '@shared/commonFunctions';
import { LoaderBackdrop } from '@shared/components/LoaderBackdrop';
import { Modal } from '@shared/components/modals/Modal';
import { SERVICES } from '@shared/constants/apiConfig';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper } from '@styles/CommonStyles';
import { ModalWrapper } from '@styles/StyledDiv';

import { ICustomDocsList, ICustomDocsModalProps, IDocumentGenerate } from '../interface';
import { CustomDocsForm } from './CustomDocsForm';

export const CustomDocsModal = ({ 
  customDocModalPosition, 
  onClose, 
  dealId, 
  docMenuItem, 
  handleDoc,
}: ICustomDocsModalProps) => {
    
  const { data: customDocsData, error } = useSWR<ICustomDocsList[]>(
    withQueryParams(
      `${SERVICES.DOCUMENT}/documents/${dealId}/documenttypes`,
      { documentGeneratedType: docMenuItem.docTypeId },
      false,
    ),
  );

  const docsFields: IDocumentGenerate = {
    dealId: dealId,
    documentGenerationType: docMenuItem.docTypeId,
    ignoreProducts: true,
    isEmailCustomerTitleDocGen: false,
    isScanStipTitleDocGen: false,
    filterDocumentTypeIds: [],
  };

  const toggleSelectAll = (
    data: ICustomDocsList[],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    values: IDocumentGenerate,
  ) => {
    if (values.filterDocumentTypeIds.length === data.length) {
      setFieldValue('filterDocumentTypeIds', []);
    } else {
      const ids = data.map((item: ICustomDocsList) => {
        return item.id;
      });
      setFieldValue('filterDocumentTypeIds', ids);
    }
  };

  const handleSubmit = async(docsData: IDocumentGenerate) => {
    // check if docs has length
    const products =
      customDocsData
        ?.filter((d) => docsData.filterDocumentTypeIds.includes(d.id))
        .filter((d) => d.name === 'Products') || [];
    handleDoc({ ...docsData, ignoreProducts: products.length === 0 }, docMenuItem, false);
    onClose();
  };

  return (
    <Modal
      hideBackdrop
      open={!!customDocModalPosition} 
      resetPosition={customDocModalPosition}
      title="Select Documents"
      dialogWidth={'400px'} 
      onClose={onClose}
    >
      <LoaderBackdrop open={!customDocsData && !error} />

      <ModalWrapper>
        <Formik enableReinitialize initialValues={docsFields} onSubmit={handleSubmit}>
          {(props) => (
            <Form>
              {customDocsData && customDocsData.length ? (
                <CustomDocsForm customDocsList={customDocsData as ICustomDocsList[]} values={props.values} />
              ) : (
                <Typography variant="h3">{!customDocsData && !error ? 'Loading' : 'No documents found'}</Typography>
              )}

              {customDocsData && (
                <CommonButtonWrapper gap={1}>
                  <CancelButton
                    width="90px"
                    label={props.values.filterDocumentTypeIds.length === customDocsData.length
                      ? 'Deselect all'
                      : 'Select All'}
                    onClick={() => toggleSelectAll(customDocsData, props.setFieldValue, props.values)}
                  />
                  <SaveButton
                    width="90px"
                    label="Generate"
                    disabled={!props.values.filterDocumentTypeIds.length}
                  />
                </CommonButtonWrapper>
              )}
            </Form>
          )}
        </Formik>
      </ModalWrapper>
    </Modal>
  );
};
